import { PricingMode } from '@mews/enums';
import { LocalizedCurrencyValue, LocalizedCurrencyValueProps } from '@mews/framework/localization';

interface LocalizedCurrencySimpleValueProps extends Omit<LocalizedCurrencyValueProps<unknown, {}>, 'options'> {}

export const LocalizedCurrencySimpleValue = ({ value, ...rest }: LocalizedCurrencySimpleValueProps) => (
    <LocalizedCurrencyValue
        options={{
            pricingMode: PricingMode.Simple,
        }}
        value={value}
        {...rest}
    />
);
